import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import {   Response, Headers, ResponseContentType, RequestMethod } from '@angular/http';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment.prod';
 import { Observable } from 'rxjs';
import { Speaker } from '../entity/Speaker';
import { Badge } from '../entity/badge';
 
 
//import { environment } from '../../../../environments/environment';
//import { Logger } from '../../../core/logger/logger.service';
 
 

export interface SpeakerService{
  idSpeaker:number;
}

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class SpeakerService {
 
    private baseUrl = environment.restApi;
    private speakerUrl = `${this.baseUrl}speaker`;

    constructor( private http: HttpClient   ) {
    }

    /** 
     * GET: get all abstractEntities from the database 
     */
    getAllSpeakerEntities(type:string): Observable<any> {
         return this.http
            .get<Speaker[]>(this.speakerUrl+'/findByType/'+type) ;
    }
   
    orederBySpeaker(): Observable<any> {
        return this.http
           .get<Speaker[]>(this.speakerUrl+'/orederBySpeaker')
           .pipe(
               tap(_ => this.notify('fetched abstractEntities', 'GET')),
               catchError(this.handleError('getSpeakers', 'GET'))
           );
   }
    findRange(from:number,to:number): Observable<any> {
        return this.http
           .get<Speaker[]>( `${this.speakerUrl}/${from}/${to}`)
           .pipe(
               tap(_ => this.notify('fetched abstractEntities', 'GET')),
               catchError(this.handleError('getSpeakers', 'GET'))
           );
   }

    /** 
     * GET: get an existing speaker from the database by an id 
     */
    getSpeaker(id: number): Observable<any> {
        const url = `${this.speakerUrl}/${id}`;
        return this.http
            .get<Speaker>(url)
            .pipe(
                tap(_ => this.notify(`fetched speaker id=${id}`, 'GET')),
                catchError(this.handleError(`getSpeaker id=${id}`, 'GET'))
            );
    }

    findByExhibitor(idClient: number):Observable<Speaker[]> {
        //console.log("idClient"+idClient);
        
      return this.http
      .get<Speaker[]>(`${this.speakerUrl}/findByClient/${idClient}`)
      .pipe(
          tap(_ => this.notify('fetched abstractEntities', 'GET')),
          catchError(this.handleError('getSpeakers', 'GET'))
      );
    }
    print(speaker: Speaker ): any {
        return this.http.get(this.speakerUrl + '/printPdf/' + speaker.idSpeaker, { responseType: "blob"})  ;
      }
      private getHeaders1() {
        const headers = new Headers();
        headers.append('Accept', 'application/pdf');
        headers.append('Content-Type', 'application/pdf');
        return headers;
      }
       

    /** 
     * POST: add a new speaker to the database 
     */
    addSpeaker(speaker: Speaker): Observable<Speaker> {
 
        return this.http
            .post<Speaker>(this.speakerUrl, speaker, httpOptions)
            .pipe(
                tap((speaker: Speaker) => this.notify(`added Speaker w/ id=${speaker.idSpeaker}`, 'POST')),
                catchError(this.handleError('addSpeaker', 'POST'))
            );
    }

    /** 
     * PUT: update an existing speaker to the database 
     */
    updateSpeaker(speaker: Speaker): Observable<any> {
        return this.http
            .put(`${this.speakerUrl}/${speaker.idSpeaker}`, speaker, httpOptions) ;
    }
    sentDate(speaker: Speaker): Observable<any> {
        //console.log(JSON.stringify(speaker));
        
        return this.http
            .put(`${this.speakerUrl}/sentDate/${speaker.idSpeaker}`, speaker, httpOptions) ;
    }

    /** 
     * DELETE: delete an existing hero from the database 
     */
    deleteSpeaker(speaker: Speaker | number): Observable<any> {
        const id = typeof speaker === 'number' ? speaker : speaker.idSpeaker;
        const url = `${this.speakerUrl}/${id}`;
        return this.http
            .delete<Speaker>(url, httpOptions)
            .pipe(
                tap(_ => this.notify(`deleted speaker id=${id}`, 'DELETE')),
                catchError(this.handleError('deleteSpeaker', 'DELETE'))
            );
    }

 
    
  

 /*

    private subject = new Subject<any>();

    subscribeStandClient(clientId: number) {
   this.subject.next(clientId);
   }
    
     
    
    getSelectedStand(): Observable<any> {
        return this.subject.asObservable();
    }
*/
    /**
     * Prepare an error handler for failed HTTP requests.
     * That handler extracts the error message and logs it.
     * It also adds the message to the errors$ observable to which the caller
     * may listen and react.
     * @param operation The name/description of the operation that failed
     * @param method The HTTP method for the failed HTTP request
     */
    protected handleError(operation: string, method: string) {
        return function errorHandler(res: HttpErrorResponse) {
            this.logger.error(res);
            const eMsg = res.message || '';
            const error = `${this.entityNamePlural} ${operation} Error${
                eMsg ? ': ' + eMsg : ''
                }`;
            this.notify(error, method);
        }.bind(this);
    }

    protected notify(message: string, method: string) {
     }



 copyFromBadg(badge:Badge  ) : Speaker {
let speaker =new Speaker();
 speaker.nom=badge.nom +" "+badge.prenom;
 speaker.uid= badge.id;
 speaker.mobile=badge.mobile;
 speaker.position=badge.position;
 speaker.mail=badge.mail;
 speaker.description=badge.typeBadge;
 speaker.entreprise=badge.company;
let client=badge.entreprise.replace('badgesclient',"");

let idClient=+client/4560;

speaker.idClient=idClient;

return speaker;
 }


     
}
